module.exports = __webpack_public_path__ + "img/halfrate.15fb9874.svg";